import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { Creators as ProfileCreators } from "model/profileModal"
import { getSelectedDate, getEarliestDate, getLatestDate, getStartDate, getEndDate, getDriftDates } from "modules/security-profile/selectors/dates"
import { getOptions, getFilteredData, getCategoryItemsSubset } from "./selectors/data"
import { getDisplayType } from "./selectors/items"
import { computePositionSet } from "modules/security-profile/helpers/security"
import { getExposureAttributionData, getFirstHistoricalExposureDate, getMaxFactors } from "./selectors/exposure"
import { getDetails } from "./selectors/details"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    driftDates: getDriftDates(state, props),
    startDate: getStartDate(state, props),
    endDate: getEndDate(state, props),
    selectedDate: getSelectedDate(state, props),
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "securityExposureHistory",
    url: ({ modelId, security: { assetClass, ticker, mic, modelProviderId }, base, driftDates, startDate, endDate }) => {
      const from = startDate < driftDates.startDate ? startDate : driftDates.startDate
      const to = driftDates.endDate

      if (base) {
        if (!base.type) {
          base = {
            dates: [{
              date: from,
              ...base,
            }],
          }
        }
      }

      return {
        id: `securityExposureHistory-${modelId}${ticker}${mic}${startDate}${endDate}${JSON.stringify(base)}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
          model (id: $modelId) {
            simulation(positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
              exposure {
                date
                factors { id name category net }
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            dates: [{
              date: startDate,
              ...computePositionSet(assetClass, ticker, mic, modelProviderId),
            }],
          },
          base,
          from,
          to,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    earliestDate: getEarliestDate(state),
    latestDate: getLatestDate(state),
    data: getFilteredData(state),
    items: getCategoryItemsSubset(state),
    options: getOptions(state),
    details: getDetails(state),
    firstDate: getFirstHistoricalExposureDate(state),
    ...state.modules.securityProfileExposure,
    displayType: getDisplayType(state),
    exposureAttribution: getExposureAttributionData(state, props),
    maxFactors: getMaxFactors(state, props),
  }),
  actions: {
    ...Creators,
    setDate: PortfolioRootCreators.setProfileDate,
    resetDate: PortfolioRootCreators.resetProfileDate,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
